import { Container, Button,Alert, Modal, Col, Row , Form} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper} from "../ContentStyles";
import useBackend, {CallAPI, Loading, IsLoggedIn, Check} from '../../services/useBackend_v2';
import React, {useMemo, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import {Branding, DateTimeToLocal} from '../../services/misc';

export default function IOTCore() {
    const { loading, data, Refresh, resultSuccess, resultVariant, resultVisible, resultText, Update, XCall } =  useBackend('/api/iotcore');

    const [modalshow,  setModalshow] = useState(false);    
    const initModal = () => { Refresh(); return setModalshow(!modalshow) }    

    const [selectedDeviceData, setSelectedDeviceData]   = useState({Name:"...", IOTConnection: {Online:false, Temp : 0} , DeviceType: { DeviceCommands: []} });

    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });

    var typingTimeout = null;

    function handleChange(event){
	    clearTimeout(typingTimeout);
	    typingTimeout = setTimeout(handleSave, 1000);

		const FrmDevice = document.getElementById('FrmDevice');
		const formData = new FormData(FrmDevice);
		const formDataObj = Object.fromEntries(formData.entries());

        selectedDeviceData.Description=formDataObj.Description;
        selectedDeviceData.Hidden= formData.has('Hidden') ? true : false;
    }

    async function handleSave(){
        const { errorsException } = await XCall('/api/iotcore/'+selectedDeviceData.Guid, "PATCH", 3000, selectedDeviceData, true);
    }

    const detailShopClick = async (event, rowData)  =>  {
        setSelectedDeviceData(rowData.original)
        setModalshow(!modalshow);        
    }
    
    const columns = useMemo(() => [
        { size: 100, accessorKey: 'Description', header: 'Description' },
        { size: 100, accessorKey: 'ChipID', header: 'ChipID' },
        { size: 100, accessorKey: 'IOTConnection.Reconnections', header: 'Reconnections' },
        { size: 100, accessorKey: 'IOTConnection.RSSI',     header: 'RSSI' },                    
        {
            size: 20, header: 'Online', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
            Cell: ({ row }) => (<Check checked={row.original.IOTConnection.Online} />),
        },             
      ]
    );  

    const initialState = 
    { 
        density: 'compact',
        columnVisibility: { Company: false, Description:true }, 
        pagination : pagination 
    };  

    const state = { pagination : pagination };      

    async function sendCommand(event){
        const command = event.currentTarget.getAttribute("command");
        await XCall('/api/iotcore/'+selectedDeviceData.Guid+'/command',"PUT", 3000, { command: command }, true);
    }

    if (!loading && resultSuccess) {
        return (
            <ContentWrapper>
                <Modal show={modalshow} onHide={initModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{selectedDeviceData.Description} ({selectedDeviceData.ChipID})</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form id="FrmDevice">
                        <Row>
                            <Form.Group className="mb-3" >
                                <Form.Label>Description</Form.Label>
                                <Form.Control type="text" name="Description" id="Description" placeholder="Description" defaultValue={selectedDeviceData.Description} onChange={handleChange} />
                            </Form.Group>                    
                        </Row>
                        <Row>
                            <Col>ChipID</Col><Col>{selectedDeviceData.ChipID}</Col>                        
                        </Row>

                        <Row>
                            <Col>DeviceType</Col><Col>{selectedDeviceData.DeviceType.Description}</Col>                        
                        </Row>

                        <Row>
                            {/* SplitoutLocalTimeFromISO( */}
                            <Col>LastHeartbeat</Col><Col>{DateTimeToLocal(selectedDeviceData.IOTConnection.LastHeartbeat)}</Col>                        
                        </Row>

                        <Row>
                            <Col>SSID</Col><Col>{selectedDeviceData.SSID}</Col>                        
                        </Row>
                        <Row>
                            <Col>IPAddr</Col><Col>{selectedDeviceData.IPAddr}</Col>                        
                        </Row>                        

                        <Row>
                            <Col>Online</Col><Col><Check checked={selectedDeviceData.IOTConnection.Online} /></Col>                        
                        </Row>

                        <Row>
                            <Col>Temperatur</Col><Col>{selectedDeviceData.IOTConnection.Temp}</Col>                        
                        </Row>

                        <Row>
                            <Col>RSSI</Col><Col>{selectedDeviceData.IOTConnection.RSSI}</Col>                        
                        </Row>

                        <Row>
                            <Form.Group className="mb-3" >
                                <Form.Check type="switch" name="Hidden" id="Hidden" label="Dölj" defaultChecked={selectedDeviceData.Hidden} onChange={handleChange} />
                            </Form.Group>                    
                        </Row>       
                        </Form>                 

                        <div style={{marginTop:'12px'}}>
                            <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert>
                        </div>
                  </Modal.Body>
                  <Modal.Footer>
                    {selectedDeviceData.DeviceType.DeviceCommands.map((item) => {
                        return <div><Button variant="primary" type="button" style={{backgroundColor:Branding().ButtonColor}} disabled={!selectedDeviceData.IOTConnection.Online} command={item.Command} onClick={sendCommand}>{item.Name}</Button>&nbsp;</div>
                    })}
                  </Modal.Footer>
                </Modal>

                <Container>
                    <Sida>                    
                        <MaterialReactTable  columns={columns} data={data.Devices} 
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false ,labelRowsPerPage:"Rader", rowsPerPageOptions: [25, 50, 100]}}
                            renderTopToolbarCustomActions={() => (<Rubrik>Uppkopplade Enheter</Rubrik>)} initialState={initialState} onPaginationChange={setPagination} state={state} 
                                muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                                
                                muiTableBodyRowProps={({ row }) => ({
                                    onClick: (event) => {
                                        detailShopClick(event, row);
                                    },
                                    sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                    },
                                })}
                        />                                            
                    </Sida>
                </Container>
            </ContentWrapper>            
        );
    } else {
        return (<Loading />);         
    }
}